import type {User as UserType, UserStats} from './../types'
import UserMinimal from "~/repository/models/UserMinimal";

export default class User extends UserMinimal implements UserType {
    bio: string;
    is_adult: boolean
    stats: UserStats
    is_followed: boolean
    is_following: boolean
    is_subscribed: boolean
    is_verified: boolean
    is_age_verified: boolean
    banReason?: string;
    banReasonDescription?: string;
    banExpiry?: string;

    constructor(data: UserType) {
        super(data)
        this.bio = data.bio
        this.is_adult = data.is_adult
        this.stats = data.stats
        this.is_following = data.is_following
        this.is_followed = data.is_followed
        this.is_subscribed = data.is_subscribed
        this.is_verified = data.is_verified
        this.is_age_verified = data.is_age_verified
        this.banReason = data.banReason || null;
        this.banReasonDescription = data.banReasonDescription || null;
        this.banExpiry = data.banExpiry || null;
    }
}
